// extracted by mini-css-extract-plugin
export var container = "_4j-0";
export var infoButton = "_4j-1";
export var label = "_4j-3";
export var labelExpanded = "_4j-4";
export var price = "_4j-5";
export var priceExpanded = "_4j-6";
export var title = "_4j-2";